export default __webpack_public_path__ + "static/media/sb-img.9b017c3d.webp";